module.exports = __webpack_public_path__ + "img/抖动特效--大图.3f4a32a4.png";